import styled from "styled-components";
import { GenericSvg } from "../../assets/svgs/GenericSVG";
import { VersionTag } from "../../core/components/VersionTag";

export const LoadingScreen = () => {
  return (
    <Container>
      <StyledGenericSvg name="LogoSmall" />
      <VersionTag />
    </Container>
  );
};

const Container = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: ${({ theme }) => theme.colors.dark};
  min-height: 100vh;
  height: 100vh;
  overflow: hidden;
  gap: 20px;
`;

const StyledGenericSvg = styled(GenericSvg).attrs(({ theme }) => ({
  primaryColor: theme.colors.white,
}))`
  height: 120px;
  @keyframes scaleAnimation {
    0% {
      transform: scale(1);
    }
    50% {
      transform: scale(1.5);
    }
    100% {
      transform: scale(1);
    }
  }
  animation: scaleAnimation 4s linear infinite;
`;
